export function isBrowserMSInternetExplorer() {

    const ua = navigator.userAgent.toLowerCase(),
        check = function(str){
            return str.test(ua);
        },
        isOpera = check(/opera/),
        isWebKit = check(/webkit/),
        isGecko = !isWebKit && check(/gecko/),
        isIE = !isOpera && check(/msie/),
        docMode = document.documentMode,
        isIE7 = isIE && (check(/msie 7/) || docMode == 7),
        isIE8 = isIE && (check(/msie 8/) && docMode != 7),
        isIE9 = isIE && check(/msie 9/),
        isIE10 = isIE && check(/msie 10/),
        isIE11 = isGecko && check(/trident/i),
        isIE6 = isIE && !isIE7 && !isIE8 && !isIE9 && !isIE10 && !isIE11;

    return isIE || isIE6 || isIE7 || isIE8 || isIE9 || isIE10 || isIE11;
}

export function isMacOS() {
    let platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        isMacOS = false;

    if (macosPlatforms.indexOf(platform) !== -1) {
        isMacOS = true;
    }			
    
    return isMacOS;
}

//Helper that returns null or the name of the property for the browser 
function getPageHiddenPropName() {    
    // if 'hidden' is natively supported just return it
    if ('hidden' in document) {
        return 'hidden';
    }

    // otherwise loop over all the prefixArray elements until we find the one
    const prefixArray = ['webkit','moz','ms','o'];
    for (let element of prefixArray){
        if ((element + 'Hidden') in document) 
            return element + 'Hidden';
    }

    // otherwise not supported
    return null;
}

//Boolean to return the value of the hidden property
export function isPageHidden() {
    const hiddenProp = getPageHiddenPropName();
    if (!hiddenProp) {
        return false;
    }

    return document[hiddenProp];
}

//Checks if the document is visible or is it just pre-rendered in memory
//  When visible, calls the function
export function callWhenPageVisible(funcToCall) {
    //Use the property name to get the prefixed event name
    const visProp = getPageHiddenPropName();
    if (!visProp) {
        //Prerendering is not supported by this browser. Just proceed with the main action.
        funcToCall();
        return;
    }

    //If here, prerendering is supported.        
    if (!isPageHidden()) {
        //The document is visible. We proceed with the main action.
        funcToCall();
        return;             
    }

    //If here, the document is hidden. Bind to the next visibility change event.       
    const visChangeEvt = visProp.replace(/[H|h]idden/,'') + 'visibilitychange';
    document.addEventListener(visChangeEvt, () => callWhenPageVisible(funcToCall), false);
}

export function isWebExtensionsEnabled() {
    let usingWebExtensionsDiv = document.getElementById('BiscUsingWebExtensions');
    return (typeof(usingWebExtensionsDiv) != 'undefined' && usingWebExtensionsDiv != null);
}